/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	
	  (0, _module.preload)();
	  (0, _module.anchorLink)();
	  (0, _module.fadeItem)();
	  (0, _module.mobileMenu)();
	  (0, _module.scrollStar)();
	  (0, _module.movieSwiper)();
	  (0, _module.showMovie)();
	  (0, _module.bnr_modal)();
	})();
	
	$(window).on('load', function () {
	  setTimeout(function () {
	    (0, _module.scrollAnimation)();
	  }, 100);
	});
	$(window).on('scroll', function () {
	  (0, _module.scrollAnimation)();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakPoint = 767;
	// let resizeFlag   = false;
	var windowWidth = window.innerWidth;
	// let windowHeight = window.innerHeight;
	// let windowWidthJ = $(window).width();
	
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	  $("a[href^=#]").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "swing");
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// fadeItem
	// ----- BOTH
	// ------------------------------------------------------------------------
	var fadeItem = function fadeItem() {
	  $(window).on("scroll load", function () {
	    $(".anim").each(function () {
	      var imgPos = $(this).offset().top;
	      var scroll = $(window).scrollTop();
	      var windowHeight = $(window).height();
	      if (scroll > imgPos - windowHeight + windowHeight / 10) {
	        $(this).addClass("fadein");
	      } else {
	        return;
	      }
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// mobileMenu
	// ----- BOTH
	// ------------------------------------------------------------------------
	var mobileMenu = function mobileMenu() {
	  $('.st-Header_Hamburger > button, .st-Header_Slide_Close').on('click', function () {
	    $(this).toggleClass("opened");
	    $(this).parent().toggleClass("opened");
	    $(".st-Header_Slide").toggleClass("menu_open");
	    $(".st-Header_Slide_Inner").toggleClass("menu_open");
	  });
	};
	
	// ------------------------------------------------------------------------
	// scrollStar
	// ----- BOTH
	// ------------------------------------------------------------------------
	var scrollStar = function scrollStar() {
	  $(window).on('scroll', function () {
	    var scrollTop = $(window).scrollTop();
	    var bgPosition = scrollTop / 20;
	    if (bgPosition) {
	      // $("#style").html('body:after{background-position: center top -'+ bgPosition + 'px; }');
	      if (scrollTop > 300) {
	        $("#style").html('body:after{opacity: 1;background-position: center top -' + bgPosition + 'px; }');
	      } else {
	        $("#style").html('body:after{opacity: 0;background-position: center top -' + bgPosition + 'px; }');
	      }
	    }
	  });
	};
	
	// preload
	var preload = function preload() {
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	    $(".idx-Main").addClass("loaded");
	  });
	};
	
	// ------------------------------------------------------------------------
	// js-Animation
	// ------------------------------------------------------------------------
	var scrollAnimation = function scrollAnimation() {
	  var winScroll = $(window).scrollTop();
	  var winHeight = $(window).height();
	  // js-Animation
	  $('.js-Animation').each(function () {
	    var target = $(this);
	    if (windowWidth > breakPoint) {
	      if (target.offset().top < winScroll + winHeight * .9) {
	        target.addClass('animated');
	      }
	    } else {
	      if (target.offset().top < winScroll + winHeight * .9) {
	        target.addClass('animated');
	      }
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// swiper
	// ------------------------------------------------------------------------
	var movieSwiper = function movieSwiper() {
	  var swiper = new Swiper('.swiper', {
	    // Optional parameters
	    loop: true,
	    allowTouchMove: true,
	    loopAdditionalSlides: 1,
	    // If we need pagination
	    pagination: {
	      el: '.swiper-pagination',
	      clickable: true
	    },
	    breakpoints: {
	      768: {
	        slidesPerView: 2,
	        loopAdditionalSlides: 2,
	        grabCursor: true,
	
	        // Navigation arrows
	        navigation: {
	          nextEl: '.swiper-button-next',
	          prevEl: '.swiper-button-prev'
	        }
	      }
	    }
	  });
	};
	
	/*-------------------------------------------------------------------*/
	/* movieモーダル */
	/*-------------------------------------------------------------------*/
	// movie
	var showMovie = function showMovie() {
	  // const $modal = $('#movie-Stage');
	  var $content = $('#movie-Iframe');
	  // open
	  $('body').on('click', '.js-Youtube', function () {
	    var dataID = $(this).attr('data-youtube');
	    console.log(dataID);
	    $('#movie-Stage').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + 'vh', 'top': 0, 'left': 0 }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
	      // // fadeIn
	      // $modal.stop().fadeIn(400);
	      return false;
	    });
	  });
	  //close
	  $('#movie-Close,#movie-Iframe').on('click', function () {
	
	    $('#movie-Stage').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	      $('#movie-Stage').css({ 'display': 'none' });
	      $content.children('iframe').remove();
	    });
	  });
	};
	
	/*-------------------------------------------------------------------*/
	/* movieモーダル */
	/*-------------------------------------------------------------------*/
	// movie
	var bnr_modal = function bnr_modal() {
	  if ($('div').hasClass('afterparty_modal')) {
	    var $content = $('#afterparty_modal');
	    $($content).fadeIn();
	    var $contentOverlay = $('#afterparty_modal_overlay');
	    var $contentHamburger = $('#afterparty_modal_hamburger');
	    $($contentOverlay).on('click', function () {
	      $($content).fadeOut();
	    });
	    $($contentHamburger).on('click', function () {
	      $($content).fadeOut();
	    });
	  }
	};
	
	exports.preload = preload;
	exports.anchorLink = anchorLink;
	exports.fadeItem = fadeItem;
	exports.mobileMenu = mobileMenu;
	exports.scrollStar = scrollStar;
	exports.scrollAnimation = scrollAnimation;
	exports.movieSwiper = movieSwiper;
	exports.showMovie = showMovie;
	exports.bnr_modal = bnr_modal;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js